import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  flightDetailsModal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  flightDetailsClose: {
    color: Theme.palette.primary.light,
    height: '30px',
    position: 'absolute',
    right: '30px',
    top: '30px',
    width: '30px',
    [Theme.breakpoints.down('sm')]: {
      right: '20px',
    },
  },
  flightDetailsBody: {
    outline: 'none',
    fontFamily: Theme.typography.base.regular,
    position: 'absolute',
    width: '860px',
    backgroundColor: Theme.palette.white,
    maxHeight: '700px',
    overflow: 'auto',
    boxShadow: `0 2px 4px 0 ${Theme.palette.shadowOpacity}`,
    [Theme.breakpoints.down('lg')]: {
      width: '780px',
    },
    [Theme.breakpoints.down('md')]: {
      width: '90%',
      maxHeight: '95%',
    },
  },
  flightDetailsTitle: {
    color: Theme.palette.primary.main,
    display: 'flex',
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[6],
    lineHeight: '150%',
    margin: '70px 70px 0 70px',
    [Theme.breakpoints.down('sm')]: {
      margin: '60px 30px 20px 20px',
      fontSize: Theme.typography.size[3],
    },
  },
  multiAirlineLogo: {
    alignSelf: 'center',
  },
  flightDetailsDate: {
    marginLeft: '10px',
  },
  expandedItineraryModal: {
    margin: '30px 118px 30px 105px',
    '&:last-child': {
      marginBottom: '70px',
    },
    [Theme.breakpoints.down('lg')]: {
      marginRight: '88px',
    },
    [Theme.breakpoints.down('md')]: {
      marginRight: '63px',
    },
    [Theme.breakpoints.down('sm')]: {
      margin: '30px 30px 30px 45px',
      '&:last-child': {
        marginBottom: '50px',
      },
    },
  },
}));

export default useStyles;
